/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Taggroups_All1Inputs */

const id_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Tag`)
};

const ms_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua Tag`)
};

const da_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Tags`)
};

const de_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Tags`)
};

const en_us2_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Tags`)
};

const es_es2_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las etiquetas`)
};

const es_mx2_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las etiquetas`)
};

const fil_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng Tag`)
};

const fr_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les tags`)
};

const it_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i tag`)
};

const hu_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden címke`)
};

const nl_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle tags`)
};

const no_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle tagger`)
};

const pl_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie tagi`)
};

const pt_br2_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as tags`)
};

const pt_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as etiquetas`)
};

const ro_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate etichetele`)
};

const fi_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tagit`)
};

const sv_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla taggar`)
};

const vi_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả thẻ`)
};

const tr_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Etiketler`)
};

const cs_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny štítky`)
};

const bg_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички етикети`)
};

const ru_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все теги`)
};

const uk_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі теги`)
};

const ar_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع الوسوم`)
};

const hi_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी टैग`)
};

const th_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แท็กทั้งหมด`)
};

const ja_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのタグ`)
};

const zh_cn2_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有标签`)
};

const zh_hant1_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有標籤`)
};

const ko_search_taggroups_all1 = /** @type {(inputs: Search_Taggroups_All1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 태그`)
};

/**
* | output |
* | --- |
* | "All Tags" |
*
* @param {Search_Taggroups_All1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_taggroups_all1 = /** @type {((inputs?: Search_Taggroups_All1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Taggroups_All1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_taggroups_all1(inputs)
	if (locale === "ms") return ms_search_taggroups_all1(inputs)
	if (locale === "da") return da_search_taggroups_all1(inputs)
	if (locale === "de") return de_search_taggroups_all1(inputs)
	if (locale === "en-US") return en_us2_search_taggroups_all1(inputs)
	if (locale === "es-ES") return es_es2_search_taggroups_all1(inputs)
	if (locale === "es-MX") return es_mx2_search_taggroups_all1(inputs)
	if (locale === "fil") return fil_search_taggroups_all1(inputs)
	if (locale === "fr") return fr_search_taggroups_all1(inputs)
	if (locale === "it") return it_search_taggroups_all1(inputs)
	if (locale === "hu") return hu_search_taggroups_all1(inputs)
	if (locale === "nl") return nl_search_taggroups_all1(inputs)
	if (locale === "no") return no_search_taggroups_all1(inputs)
	if (locale === "pl") return pl_search_taggroups_all1(inputs)
	if (locale === "pt-BR") return pt_br2_search_taggroups_all1(inputs)
	if (locale === "pt") return pt_search_taggroups_all1(inputs)
	if (locale === "ro") return ro_search_taggroups_all1(inputs)
	if (locale === "fi") return fi_search_taggroups_all1(inputs)
	if (locale === "sv") return sv_search_taggroups_all1(inputs)
	if (locale === "vi") return vi_search_taggroups_all1(inputs)
	if (locale === "tr") return tr_search_taggroups_all1(inputs)
	if (locale === "cs") return cs_search_taggroups_all1(inputs)
	if (locale === "bg") return bg_search_taggroups_all1(inputs)
	if (locale === "ru") return ru_search_taggroups_all1(inputs)
	if (locale === "uk") return uk_search_taggroups_all1(inputs)
	if (locale === "ar") return ar_search_taggroups_all1(inputs)
	if (locale === "hi") return hi_search_taggroups_all1(inputs)
	if (locale === "th") return th_search_taggroups_all1(inputs)
	if (locale === "ja") return ja_search_taggroups_all1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_taggroups_all1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_taggroups_all1(inputs)
	return ko_search_taggroups_all1(inputs)
});
export { search_taggroups_all1 as "search.tagGroups.all" }